document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.benefits-tabs').forEach(function (tabs) {
    tabs.addEventListener('click', function (e) {
      var btn = e.target.closest('.benefits-tab');
      if (!btn) return;
      var targetId = btn.getAttribute('data-target');
      if (!targetId) return;

      // Active state
      tabs.querySelectorAll('.benefits-tab').forEach(function (b) {
        b.classList.toggle('benefits-tab--active', b === btn);
      });

      var sectionId = tabs.getAttribute('data-section-id');
      var group = document.querySelector('.benefits__product-group[data-section-id="' + sectionId + '"]');
      if (!group) return;
      group.querySelectorAll('.benefits__product').forEach(function (panel) {
        panel.classList.toggle('benefits__product--visible', panel.id === targetId);
      });

      // Sync image set
      var imgWrap = document.querySelector('.benefits__image[data-section-id="' + sectionId + '"]');
      if (imgWrap) {
        var linkTargetId = targetId === 'thc-' + sectionId ? 'link-thc-' + sectionId : 'link-nonthc-' + sectionId;
        imgWrap.querySelectorAll('.benefits__image-link').forEach(function (set) {
          set.classList.toggle('benefits__image-link--visible', set.id === linkTargetId);
        });

        var imgTargetId = targetId === 'thc-' + sectionId ? 'img-thc-' + sectionId : 'img-nonthc-' + sectionId;
        imgWrap.querySelectorAll('.benefits__image-set').forEach(function (set) {
          set.classList.toggle('benefits__image-set--visible', set.id === imgTargetId);
        });
      }

      // Sync attributes
      var attrWrap = document.querySelector('.benefits__attributes[data-section-id="' + sectionId + '"]');
      if (attrWrap) {
        var attrTargetId = targetId === 'thc-' + sectionId ? 'attr-thc-' + sectionId : 'attr-nonthc-' + sectionId;
        attrWrap.querySelectorAll('.benefits__attributes-set').forEach(function (set) {
          set.classList.toggle('benefits__attributes-set--visible', set.id === attrTargetId);
        });
      }

      // Sync text
      var textWrap = document.querySelector('.benefits__text-group[data-section-id="' + sectionId + '"]');
      if (textWrap) {
        var textTargetId = targetId === 'thc-' + sectionId ? 'text-thc-' + sectionId : 'text-nonthc-' + sectionId;
        textWrap.querySelectorAll('.benefits__text-set').forEach(function (set) {
          set.classList.toggle('benefits__text-set--visible', set.id === textTargetId);
        });
      }

      // Sync product title and tagline
      var titleWrap = document.querySelector('.benefits__product-title-group[data-section-id="' + sectionId + '"]');
      if (titleWrap) {
        var titleTargetId = targetId === 'thc-' + sectionId ? 'title-thc-' + sectionId : 'title-nonthc-' + sectionId;
        titleWrap.querySelectorAll('.benefits__product-title-set').forEach(function (set) {
          set.classList.toggle('benefits__product-title-set--visible', set.id === titleTargetId);
        });
      }
    });
  });
});
